import { useEffect } from 'react';
import { Box, Typography, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { LogoBlack } from '../../components/Logo/Logo';

const TermsOfServiceDE = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Box sx={{ bgcolor: "grey.C50", color: "grey.C10", px: { xs: 1, sm: 2, md: 8 }, py: { xs: 3, md: 8 } }}>

        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: { xs: 2, md: 8 } }}>
          <Box sx={{ flex: "0 0 auto", mt: 1 }}>
            <Link component={RouterLink} to="/" underline="none">
              <LogoBlack />
            </Link>
          </Box>
        </Box>

        <Box sx={{ maxWidth: '800px', mx: { xs: 0, md: 8 }, mt: { xs: 1, md: 4 } }}>

          <Typography variant="h1" sx={{ mb: { xs: 2, md: 6 }, fontWeight: 300, color: "greydark.C900", fontSize: { xs: '1.1rem', sm: '2.2rem', md: '3.75rem' } }}>
            Allgemeine Geschäftsbedingungen
          </Typography>

          <Typography variant="h4" sx={{ lineHeight: { xs: 1.5, md: 1.8 }, opacity: 0.8, fontWeight: 300, color: "greydark.C900", fontSize: { xs: '0.75rem', sm: '1rem', md: '1.25rem' } }}>
            <strong>Zuletzt aktualisiert: 9. Januar 2026</strong>
            <br /><br />

            <strong>Anwendbarkeit und anwendbares Recht</strong>
            <br /><br />
            Diese Allgemeinen Geschäftsbedingungen gelten für alle Verträge, die über die speak23-Plattform und -Dienste
            (speak23 GmbH, Unterer Schreiberweg 13/3, 1190 Wien, Österreich) zwischen uns und Ihnen als Kunden geschlossen werden.
            Unser Produktangebot richtet sich in erster Linie an Endverbraucher sowie an Geschäftskunden (B2B).
            Ein Endverbraucher ist jede natürliche Person, die ein Rechtsgeschäft zu privaten Zwecken abschließt;
            ein Unternehmer ist eine Person oder ein Unternehmen, das in Ausübung seiner gewerblichen oder selbstständigen beruflichen Tätigkeit handelt.
            Für Verbraucher mit gewöhnlichem Aufenthalt in der Europäischen Union gilt österreichisches Recht,
            unbeschadet der zwingenden Verbraucherschutzbestimmungen des jeweiligen EU-Landes.

            In Einzelfällen können für Partner spezifische Bedingungen gelten.
            In allen anderen Fällen (insbesondere bei Geschäften außerhalb der EU) gilt ausschließlich das Recht der Republik Österreich,
            unter Ausschluss des UN-Kaufrechts (CISG).
            <br /><br />

            <strong>Vertragsgegenstand</strong>
            <br /><br />
            speak23-Lösungen sind Produkte und Dienstleistungen der speak23 GmbH mit Spezialisierung auf präventive Gesundheit.
            Über unsere Plattform www.speak23.com können Kunden Produkte im Bereich der Präventivmedizin bestellen.

            Insbesondere bieten wir Bluttests in zertifizierten Labors sowie Mikrobiom-Analyse-Kits für zu Hause an.
            Bei der Darmflora-Analyse senden Sie die gesammelte Probe im beigelegten Rücksendeumschlag an unser Partnerlabor,
            wo die Analyse mittels DNA-Sequenzierung durchgeführt wird. speak23 wertet die Labordaten bioinformatisch und
            mithilfe moderner Algorithmen (einschließlich künstlicher Intelligenz) aus und stellt Ihnen
            auf Basis der verfügbaren Informationen und Blutwerte einen detaillierten Ergebnisbericht sowie
            personalisierte Empfehlungen auf unserer speak23-Plattform zur Verfügung.

            Bitte beachten Sie, dass speak23 keine medizinische Diagnose erstellt
            und der Analysebericht kein Ersatz für eine ärztliche Untersuchung ist.
            Unsere Beratung beschränkt sich auf wissenschaftliche Analysen sowie allgemeine Gesundheits- und Longevity-Tipps;
            für individuelle medizinische Beratung wenden Sie sich bitte an einen qualifizierten Fachmann.
            Ihre Probe wird in anonymisierter Form (nur über die ID) analysiert, um Privatsphäre und Vertraulichkeit zu gewährleisten.

            speak23 und Partner haben das Partnerlabor verpflichtet, alle geltenden Datenschutzvorschriften einzuhalten.

            Darüber hinaus bieten wir weitere Produkte zur Förderung der präventiven Gesundheit an.
            <br /><br />

            <strong>Benutzerprofil</strong>
            <br /><br />
            Sie benötigen ein dauerhaftes Benutzerkonto, um unsere Produkte und Empfehlungen zu bestellen und zu nutzen.
            Der Onboarding-Prozess umfasst die Benutzerregistrierung und -authentifizierung, die Mitgliedschaft im Abonnement
            sowie die Erfassung der erforderlichen personenbezogenen Daten für personalisierte Empfehlungen.
            Durch die Anmeldung mit den bereitgestellten Zugangsdaten erhält der Benutzer Zugang zu allen Informationen, Testergebnissen und Empfehlungen.

            Die Zugangsdaten für Ihr Benutzerprofil sind vertraulich zu behandeln.
            Bitte stellen Sie sicher, dass kein unbefugter Dritter Zugang zu den von uns gesendeten E-Mails oder Ihrem Passwort erhält.
            speak23 haftet nicht für Schäden, die aus einem unbefugten Zugriff auf Ihr Konto entstehen,
            sofern Sie diese durch unzureichende Sorgfalt bei der Sicherung Ihrer Zugangsdaten verursacht haben.

            Ihre Analyseergebnisse und personenbezogenen Daten werden gemäß unserer Datenschutzrichtlinie in Ihrem Profil gespeichert.
            Sie können jederzeit die Löschung Ihres Profils und Ihrer Daten beantragen, sofern keine gesetzlichen Aufbewahrungspflichten entgegenstehen.

            Bitte senden Sie Ihre Anfrage per E-Mail an office@speak23.com; wir werden Ihre Daten dann unverzüglich löschen oder sperren.
            Bitte stellen Sie sicher, dass Sie beim Onboarding oder bei der Nutzung unserer Dienste vollständige und korrekte persönliche Angaben machen.
            Sie müssen mindestens 18 Jahre alt sein, um einen speak23-Test zu bestellen oder ein Benutzerprofil anzulegen.
            <br /><br />

            <strong>Vertragsabschluss</strong>
            <br /><br />
            Die Darstellung unserer Waren und Dienstleistungen im Online-Shop stellt noch kein rechtlich bindendes Angebot dar,
            sondern eine Aufforderung zur Abgabe einer Bestellung (invitatio ad offerendum).
            Sie geben ein rechtlich bindendes Kaufangebot ab, indem Sie im Bestellprozess auf „Sicher bezahlen" klicken.
            Unmittelbar nach der Bestellabgabe erhalten Sie eine automatische Bestellbestätigung per E-Mail,
            die den Eingang Ihrer Bestellung bestätigt. Diese E-Mail stellt noch keine Annahme Ihres Angebots dar.
            Der Kaufvertrag kommt erst zustande, wenn wir Ihr Angebot ausdrücklich annehmen –
            entweder durch eine weitere E-Mail (Versandbestätigung oder Auftragsbestätigung) oder durch Lieferung der Ware.

            Bitte überprüfen Sie auch Ihren Spam-Ordner regelmäßig, da unsere E-Mails dort zugestellt werden können.
            Wenn die speak23 GmbH Ihr Angebot nicht annimmt (z. B. weil ein Produkt nicht verfügbar ist),
            werden wir Sie unverzüglich per E-Mail informieren.

            Die für den Vertragsabschluss zur Verfügung stehenden Sprachen sind Deutsch und Englisch.
            <br /><br />

            <strong>Bestellprozess / Vertragsschluss</strong>
            <br /><br />
            Im speak23-Shop oder -Konfigurator können Sie Produkte/Tests durch Hinzufügen zum Warenkorb auswählen.
            Sie können den Inhalt des Warenkorbs jederzeit einsehen und ändern.
            Wenn Sie die Bestellung abschließen möchten, klicken Sie auf „Sicher bezahlen" und folgen den weiteren Anweisungen im Checkout-Prozess.
            Sie geben dann die erforderlichen Rechnungs- und Lieferdaten ein und wählen die gewünschte Versand- und Zahlungsmethode.
            Vor der Bestellabgabe werden alle Bestelldaten und Kosten in einer Bestellübersicht zusammengefasst.
            Bitte prüfen Sie diese Übersicht sorgfältig. Sie können Eingabefehler bis zur endgültigen Bestellabgabe korrigieren
            oder den Bestellvorgang jederzeit abbrechen.

            Durch Klicken auf „Sicher bezahlen" geben Sie schließlich Ihr verbindliches Kaufangebot für die aufgeführten Produkte ab.
            Nach der Abgabe erhalten Sie unsere Bestellbestätigung per E-Mail.
            Die endgültige Annahme des Vertrags erfolgt durch unsere Versand-/Auftragsbestätigung per E-Mail oder spätestens durch die Lieferung der Ware an Sie.

            Die speak23 GmbH behält sich das Recht vor, Bestellungen im Einzelfall nicht anzunehmen – es besteht kein Anspruch auf Vertragsabschluss.
            In einem solchen Fall werden wir Sie unverzüglich informieren und bereits geleistete Zahlungen zurückerstatten.
            Wir empfehlen Ihnen, die Auftragsbestätigung/Rechnung sowie diese AGB für Ihre Unterlagen zu speichern.
            <br /><br />

            <strong>Abonnements</strong>
            <br /><br />
            Als Voraussetzung für Einzelkäufe (Add-on-Tests) bieten wir Abonnements (Daueraufträge) für speak23-Mitgliedschaft und Kern-Gesundheitstests an.
            Wenn Sie eine Abonnementbestellung aufgeben, erhalten Sie das gewählte Produkt in den von Ihnen festgelegten regelmäßigen Abständen
            (z. B. halbjährliche oder vierteljährliche Tests im ausgewählten zertifizierten Labor).

            Die Zahlung ist bei der Bestellung mit jährlicher Abrechnung fällig; Ihre Zahlungsdaten können zu diesem Zweck sicher gespeichert werden,
            um wiederkehrende Abbuchungen zu ermöglichen. Sie haben das Recht, Ihr Abonnement jederzeit zu ändern, zu pausieren oder zu kündigen,
            solange wir noch keinen Teil der nächsten Lieferung versandt oder eine entsprechende Leistung erbracht haben.
            Änderungen oder Kündigungen können über unseren Kundendienst vorgenommen werden.
            Wenn Sie ein Abonnement kündigen, nachdem ein Teil Ihrer Bestellung bereits versandt oder eine Teilleistung erbracht wurde,
            erstatten wir Ihnen den bereits bezahlten Betrag abzüglich der uns für die bereits abgeschlossene (Teil-)Lieferung entstandenen angemessenen Kosten.
            Das bedeutet, Sie zahlen nur für Produkte/Dienstleistungen, die Sie bis zum Kündigungsdatum tatsächlich erhalten haben.
            Wurde ein Abonnement mit einer festen Laufzeit vereinbart, verlängert es sich automatisch um dieselbe Laufzeit,
            sofern Sie es nicht rechtzeitig vor Ablauf kündigen.
            <br /><br />

            <strong>Widerrufsrecht</strong>
            <br /><br />
            Verbraucher im Sinne des österreichischen Konsumentenschutzgesetzes (KSchG)
            haben das gesetzliche Recht, innerhalb von 14 Tagen ohne Angabe von Gründen vom Vertrag zurückzutreten.

            Die Widerrufsfrist beträgt 14 Tage ab dem Tag, an dem Sie (oder ein von Ihnen benannter Dritter, der nicht der Spediteur ist)
            die Waren in Besitz genommen haben.
            Sobald eine digitale Dienstleistung empfangen oder verbraucht wurde, kann sie nicht mehr zurückgegeben werden.

            Ebenso ist eine Rückgabe nicht möglich, wenn ein Test nachträglich aufgewertet wurde und die Ergebnisse bereits vorliegen.
            Wurde ein Beratungstermin gebucht und ein Datum festgesetzt, kann diese Leistung nicht storniert werden.

            Um Ihr Widerrufsrecht auszuüben, müssen Sie uns (speak23 GmbH, Unterer Schreiberweg 13/3, 1190 Wien, Österreich, E-Mail: office@speak23.com)
            durch eine eindeutige Erklärung (z. B. einen per Post versandten Brief oder eine E-Mail) über Ihren Entschluss zum Widerruf informieren.

            Zur Wahrung der Widerrufsfrist genügt es, dass Sie Ihre Mitteilung vor Ablauf der 14-tägigen Frist absenden.
            Folgen des Widerrufs: Wenn Sie wirksam vom Vertrag zurücktreten, erstatten wir Ihnen alle von Ihnen geleisteten Zahlungen,
            mit Ausnahme etwaiger Bearbeitungsgebühren. Wir nehmen die Rückerstattung mit demselben Zahlungsmittel vor,
            das Sie bei der ursprünglichen Transaktion verwendet haben, sofern nicht ausdrücklich etwas anderes vereinbart wurde.
            Für die Rückerstattung werden Ihnen keine Gebühren berechnet.

            Ausnahmen: Das Widerrufsrecht gilt nicht für Waren, die aus Gründen des Gesundheitsschutzes oder der Hygiene versiegelt sind
            und nach der Lieferung entsiegelt wurden. Dies gilt insbesondere für speak23-Testkits, die bereits geöffnet oder verwendet wurden,
            da deren Inhalt aus gesundheitlichen Gründen nicht wiederverwendet werden kann.

            Hinweis: Das in diesem Abschnitt beschriebene Widerrufsrecht gilt nur für Verbraucher (nicht für Geschäftskunden).
            <br /><br />

            <strong>Zahlung und Eigentumsvorbehalt</strong>
            <br /><br />
            Die auf unserer Online-Plattform angezeigten Preise sind Gesamtpreise und enthalten die gesetzliche Umsatzsteuer.
            Etwaige zusätzliche Gebühren oder Versandkosten werden während des Bestellvorgangs gesondert ausgewiesen.
            Vor dem Abschluss der Bestellung wird der Bruttogesamtpreis Ihres Warenkorbs einschließlich aller Kosten klar angezeigt.

            Die speak23 GmbH bietet verschiedene Zahlungsmethoden an (z. B. Kreditkarte, PayPal usw.),
            ist jedoch nicht verpflichtet, bestimmte Zahlungsmethoden dauerhaft anzubieten.
            Für die Nutzung der angebotenen Zahlungsmethoden werden von der speak23 GmbH keine zusätzlichen Gebühren erhoben.

            Die Zahlung ist zum Zeitpunkt des Kaufs in voller Höhe fällig (zuzüglich etwaiger Versandkosten).
            Bei Zahlungsverzug sind wir berechtigt, Verzugszinsen in gesetzlicher Höhe zu berechnen.
            Die gelieferten Waren bleiben bis zur vollständigen Bezahlung Eigentum der speak23 GmbH (Eigentumsvorbehalt).
            <br /><br />

            <strong>Gewährleistung</strong>
            <br /><br />
            Für unsere Waren und Dienstleistungen gelten die gesetzlichen Gewährleistungsvorschriften.
            Bei Verbrauchergeschäften beträgt die Gewährleistungsfrist für neue Waren zwei Jahre ab Lieferung der Waren.
            Bei Bestellungen durch Unternehmer (B2B) ist die Gewährleistungsfrist für bewegliche Sachen auf ein Jahr ab Lieferung begrenzt,
            soweit gesetzlich zulässig.
            Weist ein geliefertes Produkt Mängel auf, stehen Verbrauchern die gesetzlichen Gewährleistungsansprüche zu
            (Verbesserung/Ergänzung, Austausch, Preisminderung oder Rücktritt gemäß §§ 922 ff ABGB).

            Bitte teilen Sie uns offensichtliche Mängel so schnell wie möglich mit und
            senden Sie die Waren im Reklamationsfall nicht ohne vorherige Kontaktaufnahme mit unserem Kundendienst an uns zurück.
            Etwaige Herstellergarantien bleiben unberührt und gelten zusätzlich gemäß den jeweiligen Garantiebedingungen.

            Für Unternehmer unterliegen Gewährleistungsansprüche der Untersuchungs- und Rügepflicht gemäß § 377 UGB.
            Reklamationen können bei uns unter den im Impressum angegebenen Kontaktdaten eingereicht werden.
            <br /><br />

            <strong>Haftung und Haftungsausschluss</strong>
            <br /><br />
            Die speak23 GmbH erbringt alle Leistungen mit größter Sorgfalt nach dem aktuellen Stand der Technik
            und ist bestrebt, eine hohe Verfügbarkeit unserer Online-Angebote sicherzustellen.

            Wir behalten uns jedoch das Recht vor, Funktionen der Website oder angebotene Dienste bei Bedarf
            zu ändern, einzuschränken oder einzustellen (z. B. zu Wartungszwecken).
            Vorübergehende Einschränkungen der Verfügbarkeit berechtigen nicht zu Schadensersatzansprüchen.

            Technische Haftungsbeschränkung: Die speak23 GmbH übernimmt keine Haftung für technische Störungen, die außerhalb unserer Kontrolle liegen,
            insbesondere nicht für unbeabsichtigte Unterbrechungen, Ausfälle, Datenverluste oder Übertragungsfehler
            im Zusammenhang mit der Nutzung unserer Online-Angebote.
            Insbesondere haften wir nicht für Verzögerungen oder Leistungsausfälle aufgrund höherer Gewalt
            (z. B. Naturkatastrophen, Streiks, Krieg, staatliche Eingriffe) oder andere unvorhersehbare Ereignisse, für die wir nicht verantwortlich sind.
            Wartungsarbeiten können zu vorübergehend eingeschränkter Verfügbarkeit führen; dies berechtigt Kunden zu keinen Ansprüchen.

            Allgemeine Haftung: Bei leichter Fahrlässigkeit haften wir nicht – außer bei Personenschäden – für Vermögensschäden.
            Für Schäden, die durch uns oder unsere Erfüllungsgehilfen durch grobe Fahrlässigkeit oder Vorsatz verursacht werden, haften wir grundsätzlich in vollem Umfang.
            Die vorstehenden Haftungsbeschränkungen gelten entsprechend für mit der speak23 GmbH verbundene Personen sowie unsere Mitarbeiter und Erfüllungsgehilfen.
            Zwingende Haftungsbestimmungen bleiben unberührt, insbesondere die Haftung für Personenschäden und die Haftung nach dem Produkthaftungsgesetz.

            Produkte und Gesundheitshinweise: Einige auf unserer Website angebotenen Produkte sind Nahrungsergänzungsmittel,
            die die Ernährung mit bestimmten Nährstoffen ergänzen sollen.
            Nahrungsergänzungsmittel sind kein Ersatz für eine abwechslungsreiche, ausgewogene Ernährung und einen gesunden Lebensstil.
            Bei bestimmungsgemäßer Verwendung haben sie bei gesunden Erwachsenen im Allgemeinen keine unerwünschten Nebenwirkungen.
            Sollten dennoch Nebenwirkungen oder gesundheitliche Probleme aufgrund individueller Unverträglichkeiten auftreten, übernimmt die speak23 GmbH keine Haftung.
            <br /><br />

            <strong>Schadloshaltung</strong>
            <br /><br />
            Sie als Kunde verpflichten sich, die speak23 GmbH schadlos zu halten und zu entschädigen,
            falls wir aufgrund Ihres Verhaltens mit Ansprüchen Dritter konfrontiert werden.
            Dies gilt insbesondere in Fällen, in denen Ansprüche Dritter daraus entstehen, dass Sie:

            (a) rechtswidrige oder fehlerhafte Inhalte in unser System eingegeben, veröffentlicht oder übermittelt haben;
            (b) unsere Website oder Dienste auf rechtswidrige Weise genutzt haben;
            (c) gegen diese AGB oder etwaige geltende Website-Regeln verstoßen haben;
            (d) Rechte Dritter (Personen oder Organisationen) verletzt haben; oder
            (e) schädliche Programme wie Viren oder Trojaner in unsere Systeme eingeschleust haben.

            In all diesen Fällen werden Sie die speak23 GmbH für alle daraus entstandenen Schäden und Aufwendungen entschädigen
            und uns von Ansprüchen Dritter freistellen.
            <br /><br />

            <strong>Schlussbestimmungen</strong>
            <br /><br />
            Auf dieses Vertragsverhältnis findet – vorbehaltlich zwingender internationaler Verbraucherschutzgesetze –
            das Recht der Republik Österreich Anwendung, unter Ausschluss der kollisionsrechtlichen Regeln des internationalen Privatrechts
            und des UN-Kaufrechts.

            Ausschließlicher Gerichtsstand für alle Streitigkeiten aus oder im Zusammenhang mit diesem Vertrag
            ist das zuständige Gericht in Wien, sofern keine zwingenden Verbraucherschutzvorschriften entgegenstehen.

            Die Vertragssprache ist Deutsch (übersetzte Versionen dienen nur Informationszwecken).
            Sollte eine Bestimmung dieser AGB unwirksam oder nicht durchsetzbar sein oder werden,
            bleiben die übrigen Bestimmungen in Kraft. An die Stelle der unwirksamen Klausel tritt die einschlägige gesetzliche Regelung.
            Gleiches gilt für etwaige Lücken.

            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung bereit: http://ec.europa.eu/consumers/odr.
            Verbraucher haben die Möglichkeit, diese Plattform zur Beilegung von Streitigkeiten aus Online-Kaufverträgen zu nutzen.
            Wir weisen jedoch darauf hin, dass wir weder verpflichtet noch bereit sind,
            an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.

            Sie können Beschwerden auch direkt an uns richten (E-Mail: office@speak23.com); wir werden uns um eine einvernehmliche Lösung bemühen.

            Links zu externen Websites oder Informationsquellen auf unserer Website dienen als Service für Kunden.
            Trotz sorgfältiger Auswahl und regelmäßiger Überprüfung übernehmen wir keine Verantwortung für den Inhalt externer Links (siehe Impressum).
            Wenn verlinkter Inhalt bedenklich erscheint, informieren Sie uns bitte, damit wir den Link entfernen können.

            Alle Marken, Logos, Grafiken und Texte auf unserer Website sind geistiges Eigentum der speak23 GmbH
            (oder der jeweiligen Rechteinhaber) und durch Urheber- und Markengesetze geschützt.
            Eine Nutzung durch Dritte ist ohne unsere vorherige schriftliche Zustimmung nicht gestattet.

            Die speak23 GmbH behält sich das Recht vor, diese AGB für die Zukunft zu ändern,
            sofern die Änderungen geringfügig, sachlich gerechtfertigt und für Verbraucher zumutbar sind.
            Wir werden Sie über geplante Änderungen per E-Mail oder über ein Pop-up auf der Plattform informieren.

            Jeder Kunde hat das Recht, innerhalb eines Monats nach Erhalt der Benachrichtigung Widerspruch gegen Änderungen einzulegen.
            Wenn Sie nicht fristgerecht widersprechen, gelten die geänderten AGB als akzeptiert.
            Wir werden Sie in der Änderungsmitteilung ausdrücklich auf diese Folge hinweisen.
            Wenn Sie fristgerecht widersprechen, behalten wir uns das Recht vor, den Vertrag ordentlich zu kündigen.

            Mit der Bestellung stimmt der Kunde diesen Allgemeinen Geschäftsbedingungen zu.
            Die aktuelle Version der AGB ist jederzeit unter www.speak23.com abrufbar.
            Wir empfehlen, diese AGB zum Zeitpunkt des Vertragsabschlusses herunterzuladen oder auszudrucken und für Ihre Unterlagen aufzubewahren.
          </Typography>
        </Box>

      </Box>
    </>
  );
};

export default TermsOfServiceDE;
